module.exports = __webpack_public_path__ + "static/img/img_empty_serv_def.43812b13.svg";